"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initDefaultSliders = initDefaultSliders;
const swiper_1 = __importDefault(require("swiper"));
const modules_1 = require("swiper/modules");
// import { disableSwipeIfScrollable } from "@/components/ui/scrollbar/scrollbar";
const helpers_1 = require("../../../../scripts/helpers");
let duplicatedSlidesElements = [];
function initDefaultSliders() {
    const swiperWrappers = Array.from(document.querySelectorAll('.slider-wrapper--primary[data-auto-init]'));
    swiperWrappers.forEach($swiperWrapper => {
        var _a, _b;
        const $SWIPER = $swiperWrapper.querySelector('.swiper');
        const IS_LOOP_DEFAULT = $swiperWrapper.hasAttribute('data-looped');
        const IS_CENTERED = $swiperWrapper.hasAttribute('data-centred');
        const DISABLED_AT = $swiperWrapper.getAttribute('data-disable-at');
        let $slidesDefault = $swiperWrapper.querySelectorAll('.swiper-slide');
        const AUTOPLAY_DELAY = Number($swiperWrapper.getAttribute('data-autoplay-delay'));
        const $prevButton = $swiperWrapper.querySelector('.slider-controls__button-prev') ||
            ((_a = $swiperWrapper.closest('.section')) === null || _a === void 0 ? void 0 : _a.querySelector('.slider-controls__button-prev'));
        const $nextButton = $swiperWrapper.querySelector('.slider-controls__button-next') ||
            ((_b = $swiperWrapper.closest('.section')) === null || _b === void 0 ? void 0 : _b.querySelector('.slider-controls__button-next'));
        const $pagination = $swiperWrapper.querySelector(':scope > .slider-pagination > .swiper-pagination');
        let paginationButtonsList = null;
        const OPTIONS = {
            slidesPerView: 'auto',
            // slidesPerGroup: 6,
            modules: [modules_1.Autoplay, modules_1.Navigation, modules_1.Pagination],
            autoplay: AUTOPLAY_DELAY ? { delay: AUTOPLAY_DELAY } : false,
            loop: IS_LOOP_DEFAULT,
            centeredSlides: IS_CENTERED,
            watchSlidesProgress: true,
            navigation: {
                enabled: true,
                prevEl: $prevButton,
                nextEl: $nextButton,
            },
            lazyPreloadPrevNext: 2,
            pagination: {
                el: $pagination,
                type: 'bullets',
                bulletElement: 'button',
                clickable: true,
                renderBullet: (index, className) => `<div class="${className}"><span></span></div>`,
            },
            breakpoints: {
                [DISABLED_AT]: {
                    enabled: false,
                },
            },
            on: {
                // init: swiper => {},
                // resize: debounce(swiper => {}, 300),
                slideChange: () => {
                    if (paginationButtonsList) {
                        const $activeBullet = $pagination.querySelector('.swiper-pagination-bullet-active');
                        if ($activeBullet) {
                            if (paginationButtonsList.length > 1)
                                $pagination.style.display = '';
                            else
                                $pagination.style.display = 'none';
                            const currentActiveBulletIndex = paginationButtonsList.findIndex(item => item === $activeBullet);
                            paginationButtonsList.forEach(($bullet, index) => {
                                const diffIndexes = Math.abs(currentActiveBulletIndex - index);
                                const scale = diffIndexes < 4 ? 1 - diffIndexes * 0.2 : 1 - 4 * 0.2;
                                $bullet.style.transform = `translateX(-${14 * currentActiveBulletIndex}px) scale(${scale})`;
                            });
                        }
                    }
                },
                // ! Есть рендер в шаблоне с сервера /handlbars.helpers.ts -> transformStyleForSliderPaginationBullets
                // ! Затем здесь делается рендеринг на стороне браузера при каждой инициализации
                paginationRender: () => {
                    paginationButtonsList = Array.from($pagination.querySelectorAll('.swiper-pagination-bullet'));
                    if (paginationButtonsList.length > 1)
                        $pagination.style.display = '';
                    else
                        $pagination.style.display = 'none';
                    const $activeBullet = $pagination.querySelector('.swiper-pagination-bullet-active');
                    if ($activeBullet) {
                        if (paginationButtonsList.length > 1)
                            $pagination.style.display = '';
                        else
                            $pagination.style.display = 'none';
                        const currentActiveBulletIndex = paginationButtonsList.findIndex(item => item === $activeBullet);
                        paginationButtonsList.forEach(($bullet, index) => {
                            const diffIndexes = Math.abs(currentActiveBulletIndex - index);
                            const scale = diffIndexes < 4 ? 1 - diffIndexes * 0.2 : 1 - 4 * 0.2;
                            $bullet.style.transform = `translateX(-${14 * currentActiveBulletIndex}px) scale(${scale})`;
                        });
                    }
                },
            },
        };
        if (IS_LOOP_DEFAULT)
            duplicateSlidesIfBugLoopExists($SWIPER, $slidesDefault, OPTIONS);
        let swiper = new swiper_1.default($SWIPER, OPTIONS);
        let lastWidth = $SWIPER.offsetWidth;
        let lastHeight = $SWIPER.offsetHeight;
        const resizeObserver = new ResizeObserver((0, helpers_1.debounce)(() => {
            const currentWidth = $SWIPER.offsetWidth;
            const currentHeight = $SWIPER.offsetHeight;
            if (currentWidth === lastWidth && currentHeight === lastHeight) {
                return;
            }
            else {
                lastWidth = currentWidth;
                lastHeight = currentHeight;
            }
            swiper = initSlider();
        }, 300));
        resizeObserver.observe($SWIPER);
        function initSlider() {
            if (swiper) {
                clearDuplicatedSlides();
                swiper.destroy(true, true);
            }
            if (IS_LOOP_DEFAULT)
                duplicateSlidesIfBugLoopExists($SWIPER, $slidesDefault, OPTIONS);
            return new swiper_1.default($SWIPER, OPTIONS);
        }
        // ! @todo проверить работает ли и прикрутить если не работает
        // disableSwipeIfScrollable(swiper);
    });
}
/**
 * Ensure that the Swiper instance meets the necessary conditions for looping. This function checks if there are enough
 * slides for looping and adds duplicates if needed.
 */
function duplicateSlidesIfBugLoopExists($SWIPER, $slidesDefault, OPTIONS) {
    OPTIONS.loop = canLoopEffect($SWIPER, $slidesDefault);
    if (OPTIONS.loop) {
        const SLIDES_EXISTS_COUNT = $slidesDefault.length;
        let slidesPerView = OPTIONS.slidesPerView;
        let slidesPerGroup = OPTIONS.slidesPerGroup || 1;
        if (slidesPerView === 'auto')
            slidesPerView = getSlidesPerContainer($SWIPER, $slidesDefault);
        if (SLIDES_EXISTS_COUNT === slidesPerView ||
            SLIDES_EXISTS_COUNT === slidesPerGroup ||
            SLIDES_EXISTS_COUNT % slidesPerGroup !== 0) {
            duplicateSlides($SWIPER, $slidesDefault, slidesPerGroup);
        }
    }
}
/** Duplicate slides in the Swiper instance to meet the minimum slide requirements. */
function duplicateSlides($SWIPER, $slidesDefault, slidesPerGroup) {
    const SLIDES_EXISTS_COUNT = $slidesDefault.length;
    let slidesToAdd = SLIDES_EXISTS_COUNT;
    let minSlides = slidesPerGroup + 1;
    const sumSlides = () => slidesToAdd + SLIDES_EXISTS_COUNT;
    let multiplier = 2;
    while (sumSlides() % slidesPerGroup !== 0 || sumSlides() < minSlides) {
        slidesToAdd = SLIDES_EXISTS_COUNT * multiplier++;
    }
    const fragment = document.createDocumentFragment();
    for (let i = 0; i < slidesToAdd; i++) {
        const slide = $slidesDefault[i % $slidesDefault.length];
        const clonedSlide = slide.cloneNode(true);
        duplicatedSlidesElements.push(clonedSlide);
        fragment.appendChild(clonedSlide);
    }
    $SWIPER.firstElementChild.appendChild(fragment);
}
function clearDuplicatedSlides() {
    if (duplicatedSlidesElements.length) {
        duplicatedSlidesElements.forEach(slide => {
            if (slide.parentNode) {
                slide.parentNode.removeChild(slide);
            }
        });
        duplicatedSlidesElements = [];
    }
}
function canLoopEffect($SWIPER, $slidesDefault) {
    const SLIDES_PER_CONTAINER_COUNT = getSlidesPerContainer($SWIPER, $slidesDefault);
    const SLIDES_COUNT = $slidesDefault.length;
    return SLIDES_COUNT >= SLIDES_PER_CONTAINER_COUNT;
}
function getSlidesPerContainer($SWIPER, $slidesDefault) {
    const CONTAINER_WIDTH = $SWIPER.clientWidth;
    const SLIDE_WIDTH = $slidesDefault[0].offsetWidth;
    const SLIDES_PER_CONTAINER_COUNT = Math.floor(CONTAINER_WIDTH / SLIDE_WIDTH);
    return SLIDES_PER_CONTAINER_COUNT;
}
